<template>
	<div class="myChart2"></div>
</template>

<script>
import { EleResize } from '@/utils/EleResize'
import * as echarts from 'echarts'
export default {
	name: 'lineCharts',
	props: {
		chartData: {
			type: Array,
			default: []
		},
	},
	data() {
		return {
			echart2: null
		}
	},
	mounted() {
		// this.ChartOne()
	},
	watch: {
		chartData: {
			handler(newVal, oldVal) {
				if (newVal && newVal.length > 0) {
					const Xdata = newVal.map(item => item.date)
					const data = newVal.map(item => item.count)
					this.$nextTick(() => {
						this.ChartOne(Xdata, data)
					})
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		ChartOne(Xdata, data) {
			this.echart2 = this.$echarts.init(document.querySelector('.myChart2'))
			let dom = document.querySelector('.myChart2')
			if (dom) {
				EleResize.on(dom, this.echart2.resize)
				this.echart2.setOption({
					color: ['#17E5DE', '#22B2FB', '#FFD300'],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '10',
						left: '5',
						right: '0',
						bottom: '10',
						containLabel: true
					},
					calculable: true,
					xAxis: [
						{
							type: 'category',
							axisTick: { show: false },
							data: Xdata,
							axisLabel: {
								show: true,
								color: '#F4FAFF',
								fontSize: 11,
								interval: 0,
								align: 'center',
								formatter: function (value, index) {
									return value.slice(8, 10)
								}
							},
							axisLine: {
								//不显示坐标轴线
								show: true,
								lineStyle: {
									color: '#2F5A8D'
								}
							},
							axisTick: {
								show: false,
								alignWithLabel: true,
								lineStyle: {
									color: '#fff',
									type: 'solid' //线的类型。'solid' 'dashed' 'dotted'
								}
							}
						}
					],
					yAxis: [
						{
							type: 'value',
							minInterval: 1,
							splitLine: {
								//网格线
								lineStyle: {
									type: 'dashed', //设置网格线类型 dotted：虚线 solid:实线
									color: 'rgba(255,255,255,0.149)'
								}
								// show: true //隐藏或显示
							},
							axisLabel: {
								show: true,
								color: '#F4FAFF',
								fontSize: 12
							}
						}
					],
					series: [
						// {
						// 	name: '发生案卷',
						// 	type: 'line',
						// 	symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
						// 	showSymbol: false,
						// 	smooth: true,
						// 	lineStyle: {
						// 		normal: {
						// 			width: 1,
						// 			color: '#22B2FB' // 线条颜色
						// 		}
						// 	},
						// 	itemStyle: {
						// 		show: false
						// 	},
						// 	symbolSize: 2, //设定实心点的大小
						// 	areaStyle: {
						// 		normal: {
						// 			//线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
						// 			color: new echarts.graphic.LinearGradient(
						// 				0,
						// 				0,
						// 				0,
						// 				1,
						// 				[
						// 					{
						// 						offset: 0,
						// 						color: 'rgba(34, 178, 255, 1)'
						// 					},

						// 					{
						// 						offset: 1,
						// 						color: 'rgba(34, 178, 255, 0)'
						// 					}
						// 				],
						// 				false
						// 			)
						// 		}
						// 	},
						// 	data: dataValue
						// },
						{
							name: '已处置告警',
							type: 'line',
							symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
							showSymbol: false,
							smooth: true,
							lineStyle: {
								normal: {
									width: 1,
									color: '#17E5DE' // 线条颜色
								}
							},
							itemStyle: {
								show: false
							},
							symbolSize: 2, //设定实心点的大小
							areaStyle: {
								normal: {
									//线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
									color: new echarts.graphic.LinearGradient(
										0,
										0,
										0,
										1,
										[
											{
												offset: 0,
												color: 'rgba(23, 229, 222, 1)'
											},

											{
												offset: 1,
												color: 'rgba(23, 229, 222, 0)'
											}
										],
										false
									)
								}
							},
							data: data
						}
					]
				})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.myChart2 {
	height: 200px;
}
</style>
